export default __webpack_public_path__ + "static/media/csv.2814d855.svg";